import { branch, renderNothing } from 'recompose';
import Component from './DraggableProfileHero';
import Container, { OwnProps } from './DraggableProfileHero.container';

export default Container(
  branch(props => !props.coverDeviation, renderNothing)(Component)
) as React.ComponentType<OwnProps>;
